// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"19":"DemandChecker","822":"PriceCheckDetailed","830":"PriceHistory"}[chunkId] + "." + {"19":"1f9ed988","822":"afc1fd9e","830":"fe46abe1"}[chunkId] + ".chunk.css";
};